export const TOAST_TYPES = {
  ERROR: "error",
  INFO: "info",
  WARN: "warn",
  SUCCESS: "success",
};
